import React, {
  FunctionComponent,
  useCallback,
  useMemo,
  useRef,
  useState,
} from 'react'
import ConteudoPagamentos from '../../../components/ConteudoPagamentos'
import { Button, Grid } from '@material-ui/core'
import { BoxValor, StyledGrid, TextBoleto } from './styles'
import { colors } from '../../../../../../shared/styles/colors'
import { numberToCurrency } from '../../../../../../shared/utils/formatters'
import { usePagamentoBoleto } from '../../../../hooks/usePagamentoBoleto'
import { format } from 'date-fns'
import { MdErrorOutline } from 'react-icons/md'
import DetalheBoleto from './DetalheBoleto'
import SelecaoTipoPagamento from './SelecaoTipoPagamento'
import { ETipoPagamentoBoleto } from '../../../../domain/entities/IPagamentoBoletoResponse'
import { isValidValue } from '../../../../../../shared/utils/validates'
import ModalSenha from '../../../components/ModalSenha'
import { useCartao } from '../../../../hooks/useCartao'
import { IVerifyPassword } from '../../../../domain/usecases/VerifyPassword'
import ModalErro from '../ModalErro'
import ModalSucesso from '../ModalSucesso'
import { useReactToPrint } from 'react-to-print'
import ComprovantePagamento from '../ComprovantePagamento'
import { useHistory } from 'react-router-dom'
import PagamentoRoutes from '../../../../utils/PagamentoRoutes'
import LoadingBackdrop from '../../../../../../shared/components/LoadingBackdrop'
import Pin from 'modules/pagamentos/pages/components/Pin'
import { IEnviarPinTmovPay } from 'modules/pagamentos/domain/usecases/EnviarPinTmovPay'
import { IValidarPinTmovPay } from 'modules/pagamentos/domain/usecases/ValidarPinTmovPay'
import { EOrigemSolicitacaoPin } from 'modules/pagamentos/domain/entities/EOrigemEnvioPin'
import { useTransferencia } from 'modules/pagamentos/hooks/useTransferencia'

interface DetalhesPagamentoBoletoProp {
  verifyPassword: IVerifyPassword
  enviarPinTmovPay: IEnviarPinTmovPay
  validarPinTmovPay: IValidarPinTmovPay
}
const DetalhesPagamentoBoleto: FunctionComponent<DetalhesPagamentoBoletoProp> =
  ({ verifyPassword, enviarPinTmovPay, validarPinTmovPay }) => {
    const history = useHistory()
    const { boleto, limpar, pagarBoleto, loading, requestError } =
      usePagamentoBoleto()
    const { pin, token } = useTransferencia()
    const { cartao, setCartao } = useCartao()
    const [tipoPagamento, setTipoPagamento] = useState(0)
    const [dataAgendamento] = useState<Date | undefined>()
    const [openModalSenha, setOpenModalSenha] = useState(false)

    const [openModalSucesso, setOpenModalSucesso] = useState(false)
    const [openModalErro, setOpenModalErro] = useState(false)
    const [protocolo, setProtocolo] = useState('')

    const [openModalPin, setOpenModalPin] = useState(false)

    const mensagemErroPagamento = useMemo(() => {
      const estaDesabilitado =
        requestError &&
        (requestError?.toLowerCase()?.includes('desabilitado') ||
          requestError?.toLowerCase()?.includes('desligado') ||
          requestError?.toLowerCase()?.includes('desativado'))
      return estaDesabilitado ? requestError : null
    }, [requestError])

    const habilitarBotaoOK = useMemo(() => {
      return (
        tipoPagamento === ETipoPagamentoBoleto.IMEDIATO ||
        (tipoPagamento === ETipoPagamentoBoleto.AGENDADO &&
          isValidValue(dataAgendamento))
      )
    }, [tipoPagamento, dataAgendamento])

    const comprovanteRef = useRef()

    const dadosBotaoOk = useMemo<{
      backgroundColor: string
      textColor: string
      borderColor
    }>(() => {
      const dados = {
        backgroundColor: '',
        textColor: colors.gray7,
        borderColor: colors.gray7,
      }
      if (
        tipoPagamento === ETipoPagamentoBoleto.IMEDIATO ||
        (tipoPagamento === ETipoPagamentoBoleto.AGENDADO &&
          isValidValue(dataAgendamento))
      ) {
        dados.backgroundColor = colors.green
        dados.borderColor = colors.green
        dados.textColor = colors.white
      }
      return dados
    }, [tipoPagamento, dataAgendamento])

    const handleOkButton = useCallback(
      async (senha: any) => {
        const responsePagamento = await pagarBoleto(
          senha,
          pin.current,
          token.current,
        )

        if (responsePagamento) {
          setProtocolo(responsePagamento.protocolo)
          setOpenModalSucesso(true)
          setOpenModalErro(false)
        } else {
          setOpenModalSucesso(false)
          setOpenModalErro(true)
        }
      },
      [habilitarBotaoOK],
    )

    const handleImpressao = useReactToPrint({
      content: () => comprovanteRef.current,
      onAfterPrint: () =>
        history.replace(PagamentoRoutes.PAGAMENTO, {
          reloadHomePagamento: true,
        }),
    })

    const handleModalPin = () => {
      setOpenModalPin(!openModalPin)
    }

    const Footer = () => {
      return (
        <Grid
          container
          spacing={2}
          style={{
            display: 'flex',
            textAlign: 'right',
            width: '100%',
            marginTop: 8,
          }}
        >
          <Grid item xs={12}>
            <Button
              style={{
                textTransform: 'capitalize',
                color: colors.green,
                borderColor: colors.green,
                height: 48,
                backgroundColor: colors.white,
                margin: 0,
                padding: 0,
                marginRight: 16,
                minWidth: 116,
              }}
              onClick={limpar}
              variant={'outlined'}
            >
              Cancelar
            </Button>
            <Button
              style={{
                textTransform: 'capitalize',
                color: dadosBotaoOk.textColor,
                borderColor: dadosBotaoOk.borderColor,
                height: 48,
                margin: 0,
                padding: 0,
                backgroundColor: dadosBotaoOk.backgroundColor,
                minWidth: 116,
              }}
              onClick={handleModalPin}
              variant={'outlined'}
              disabled={!habilitarBotaoOK}
            >
              {tipoPagamento === ETipoPagamentoBoleto.AGENDADO
                ? 'Agendar'
                : 'Pagar'}
            </Button>
          </Grid>
        </Grid>
      )
    }

    return (
      <>
        <LoadingBackdrop open={loading} />
        <ModalSenha
          setActiveMenu={() => console.log('menu ativo')}
          card={cartao}
          setCartao={setCartao}
          setOpenModalPassword={setOpenModalSenha}
          openModalPassword={openModalSenha}
          verifyPassword={verifyPassword}
          curvature={true}
          customPasswordValidation={senha => handleOkButton(senha)}
        />
        <ModalErro
          openModal={openModalErro}
          setOpenModal={setOpenModalErro}
          mensagemErro={mensagemErroPagamento}
        />
        <ModalSucesso
          openModal={openModalSucesso}
          setOpenModal={setOpenModalSucesso}
          imprimirComprovante={handleImpressao}
        />

        <ConteudoPagamentos
          title={'Pagar Boleto'}
          titleColor={'#2D3A40'}
          alignItems={'center'}
          footer={<Footer />}
        >
          <Grid
            container
            spacing={2}
            justifyContent={'center'}
            alignItems={'center'}
            alignContent={'center'}
            style={{
              display: 'flex',
              width: 512,
            }}
          >
            <StyledGrid item xs={12}>
              <BoxValor>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <TextBoleto
                      $color={colors.gray7}
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                    >
                      Valor Total
                    </TextBoleto>
                  </Grid>
                  <Grid item xs={12}>
                    <TextBoleto
                      $color={'#2D3A40'}
                      $fontSize={'40px'}
                      $fontWeight={'700'}
                    >
                      {numberToCurrency(boleto?.valor_total ?? boleto?.valor)}
                    </TextBoleto>
                  </Grid>
                  <Grid item xs={12}>
                    <TextBoleto
                      $color={colors.gray7}
                      $fontSize={'14px'}
                      $fontWeight={'400'}
                    >
                      Vencimento:{' '}
                      {format(boleto?.data_vencimento, 'dd/MM/yyyy')}
                    </TextBoleto>
                  </Grid>
                </Grid>
              </BoxValor>
            </StyledGrid>
            <SelecaoTipoPagamento
              setTipoPagamento={setTipoPagamento}
              tipoPagamento={tipoPagamento}
            />
            <StyledGrid>
              <BoxValor
                style={{
                  textAlign: 'left',
                  height: 'auto',
                  paddingLeft: 24,
                  paddingRight: 24,
                }}
              >
                <Grid
                  container
                  spacing={0}
                  alignContent={'flex-start'}
                  justifyContent={'flex-start'}
                  alignItems={'flex-start'}
                >
                  <Grid item xs={1}>
                    <MdErrorOutline size={22} />
                  </Grid>
                  <Grid item xs={11}>
                    <TextBoleto
                      $fontSize={'14px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Confira se os dados de pagamento apresentados são os mesmo
                      dados do boleto a ser pago.
                    </TextBoleto>
                  </Grid>
                </Grid>
              </BoxValor>
            </StyledGrid>
            <DetalheBoleto />
          </Grid>
        </ConteudoPagamentos>
        {openModalPin && (
          <Pin
            closeModal={handleModalPin}
            isOpened={openModalPin}
            enviarPinTmovPay={enviarPinTmovPay}
            validarPinTmovPay={validarPinTmovPay}
            setOpenModalSenha={setOpenModalSenha}
            origem={EOrigemSolicitacaoPin.FROTISTA_TMOVPAY_PAGAMENTO_BOLETO}
          />
        )}
        <ComprovantePagamento ref={comprovanteRef} protocolo={protocolo} />
      </>
    )
  }

export default DetalhesPagamentoBoleto
